import { Box, Divider, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'
import SupportFile from '../../../../../shared/components/frontoffice/SupportFile'
import { MultimediaSectionProps } from '../../../models/lessons'

export const MultimediaSection = ({ lesson, course, hasVipAccess, isMobile, onEdit, onDownload, onDelete }: MultimediaSectionProps) => {
  const { t } = useTranslation(['global'])

  if (lesson.multimedia.length === 0) return null

  return (
    <Box sx={{ mt: 4, mb: 6, display: 'grid', gap: 3 }}>
      <Divider />
      <Typography variant="subtitle1" color="primary">
        {t('downloadable-material')}
      </Typography>
      <Grid container spacing={isMobile ? 2 : 3}>
        {lesson.multimedia.map((multimedia: any) => (
          <SupportFile
            key={uuidv4()}
            data={multimedia}
            type="lessons"
            vipContent={course.visibility === 1}
            hasaccess={hasVipAccess}
            handleEdit={onEdit}
            handleDownload={onDownload}
            handleDelete={onDelete}
          />
        ))}
      </Grid>
      <Divider />
    </Box>
  )
}
